import { api } from "@/_store/api-client";
import { IGetInsurancePolicyResponse } from "./contracts";

export const insurancePolicyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInsurancePolicy: builder.query<IGetInsurancePolicyResponse, void>({
      query: () => ({
        url: "/api/v1/users/policy/",
        method: "GET",
      }),
      providesTags: ["InsurancePolicy"],
    })
  }),
  overrideExisting: false,
});

export const { useGetInsurancePolicyQuery } = insurancePolicyApi;
